import React from "react";
import PropTypes from "prop-types";
import "../styles/index.scss";
import { imgSrcs } from "../lib";

/**
 * Avatar Component acts as an placeholder for image to be displayed.
 * @param {String} src - source of the image to be displayed, it can be a http uri or data-uri.
 * @param {string} id - the top level container id
 * @param {String} altText - alt text for the image source provided.
 * @param {String | number} width - dimension of the image.
 * @param {String | number} height - dimension of the image.
 * @param {boolean} compact - controls the margin / padding on the component.
 * @param {string} variant - the variant can be company, person or biller based on which default image is loaded.
 *
 * @returns {HTMLElement}
 */
const USBBPAvatarComponent = ({
  src,
  altText,
  width,
  height,
  compact,
  variant,
  id,
  captionText,
  additionalClasses,
}) => {
  //const { avatar } = useAvatarStyle();

  const avatarSrc = !src && variant ? imgSrcs[variant] : src;
  const removeBg = src;

  return (
    <figure
      className={`avatar ${compact && "compact"} ${
        removeBg && "removeBg"
      } ${additionalClasses.join(" ")}`}
      id={`USBBPAvatarComponent-${id}`}
    >
      <img
        src={avatarSrc}
        alt={altText}
        {...{ width, height }}
        id={`USBBPAvatarComponent-${id}-image`}
      />
      {captionText && (
        <figcaption id={`USBBPAvatarComponent-${id}-caption`}>
          {captionText}
        </figcaption>
      )}
    </figure>
  );
};

USBBPAvatarComponent.propTypes = {
  /** source of the image to be displayed, it can be a http uri or data-uri */
  src: PropTypes.string.isRequired,
  /** The top level container id */
  id: PropTypes.string.isRequired,
  /** alt text for the image source provided */
  altText: PropTypes.string,
  /** controls the margin / padding on the component */
  compact: PropTypes.bool,
  /** dimension of the image */
  width: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  /** dimension of the image */
  height: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  /** the variant can be company, person or biller based on which default image is loaded */
  variant: PropTypes.string,
  /** Caption text for image */
  captionText: PropTypes.string,
  /** To add addional classes */
  additionalClasses: PropTypes.arrayOf(PropTypes.any),
};

USBBPAvatarComponent.defaultProps = {
  compact: false,
  altText: "",
  variant: "",
  src: "",
  width: "",
  height: "",
  id: "",
  captionText: "",
  additionalClasses: [],
};

export default USBBPAvatarComponent;
